import BaseDialog from "./BaseDialog";
import VariableDataModel from "../../models/VariableDataModel";
import OldInput from "../../form_components/OldInput";
import LocalVariableUsedIn from "../../utilities/usedIn/LocalVariableUsedIn";
import UsedInDialog from "../dialogs/UsedInDialog";
export default class VariableRefactorDialog extends BaseDialog {
    /**
     * Dialog for variable refactor
     * @module VariableRefactorDialog
     * @param {Object} props React render
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.name = "";
    }

    /**
     * Add to application
     * @param event
     */
    handleAdd(event) {
        if (!this.name || this.hasError) {
            return;
        }
        window.apm.refactorVariable(this.props.varId, this.props.parentModuleId, {varName: this.name});
        
        w2popup.close();
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        
        if (key === "newName"){
            this.name = value;
        }
       
    }

    /**
     * Get config proxy
     * @param {string} key
     * @returns {string}
     */
    getConfig(key) {
    
        if (key === "newName"){
            return this.name;
        }
    }

    setError(key, value){
        this.hasError = true;
    }

    removeError(key){
        this.hasError = false;
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        this.name = "";
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const varModel = window.apm.getVariable(this.props.varId, this.props.parentModuleId);
        const node = new VariableDataModel(varModel.props, varModel.id);
        const parentModuleIndex = window.apm.serialized.components.modules.findIndex(m => m.id === this.props.parentModuleId);
        const localVarUsedIn=LocalVariableUsedIn.getVariableUsedIn(varModel,window.apm.serialized.components.modules[parentModuleIndex], window.apm.serialized);
        let showUsedInMsg="";
        if(localVarUsedIn.length>0&&localVarUsedIn.filter(m=>m.mod).length>1){
            showUsedInMsg= varModel.name+" used in multiple places are you sure you want to rename?"
        }

        return (
            <div className="container-fluid">
                <div className="script-header" style={{fontWeight: "normal", display: "block"}}>
                    <div style={{width: "100%"}}>
                        <b>{window.l.popup.scope}:</b>&nbsp;&nbsp;{this.props.parentModuleId ? window.l.popup.module_cap_first : window.l.popup.application}<br/>
                    </div>
                    <div style={{width: "100%"}}>
                        <OldInput label={window.l.popup.current_variable_name}
                               context={this} valKey={"currentName"} value={node.getConfig("varName")}
                               disabled={true}/>
                    </div>
                    <div style={{width: "100%"}}>
                        <OldInput label={window.l.popup.new_variable_name}
                               context={this} valKey={"newName"} value={""}
                               valRules={{"variableName": true, "noEmpty": true, "noDuplicateVar": true}}/>
                    </div>
                </div>
                <label>
                   {showUsedInMsg} 
                </label>
                <div className="script-wrapper">
                <UsedInDialog
                        serialized={window.apm.serialized}
                        module={window.apm.serialized.components.modules[parentModuleIndex]}
                        node={varModel} isLocalVariable={true} />, 
                </div>
                <div className="script-footer">
                </div>
            </div>
        );
    }
}